import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { NotificationService } from "src/app/notifications/notification.service";
import { UiService } from "src/app/ui/ui.service";
import { AuthService } from "../auth.service";
import {
  confirmPasswordValidator,
  passwordValidator,
} from "../auth.validators";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
})
export class ResetPasswordComponent implements OnInit {
  
  resetPasswordForm = new FormGroup({
    newPassword: new FormControl("", [
      Validators.required,
      passwordValidator(),
    ]),
  });
  passwordReset = false;
  user: any;
  private onComponentDestroy = new Subject();

  constructor(
    private AuthService: AuthService,
    private Router: Router,
    private NotificationService: NotificationService,
    private route: ActivatedRoute,
    private uiService: UiService,
  ) {}

  ngOnInit(): void {
    this.user = this.route.snapshot.data.user;
    this.resetPasswordForm.addControl(
      "confirmNewPassword",
      new FormControl("", [
        Validators.required,
        confirmPasswordValidator(this.resetPasswordForm.controls.newPassword),
      ]),
    );
  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  submitNewPassword() {
    this.uiService
      .waitForEvent(
        this.AuthService.resetPassword(
          this.resetPasswordForm.controls.newPassword.value,
          this.user.id,
          this.route.snapshot.params.reset_token,
        ),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(
        () => {
          this.NotificationService.openSuccessSnackBar("Password reset");
          this.passwordReset = true;
          setTimeout(() => {
            this.Router.navigate(["auth", "login"]);
          }, 4000);
        },
        () => {
          this.NotificationService.openErrorSnackBar(
            "Error resetting password",
          );
        },
      );
  }
}
